module.exports = __webpack_public_path__ + "static/0036-229bb5598b7cfaf0178b9596470b409f.png";